// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"81":"2d10964c","153":"e2e05cd1","307":"5db3b059","365":"0549c368","588":"9b4c2e53","681":"296bbbe9","936":"aedf51e4","964":"a58d1f94"}[chunkId] + ".js";
};